import { Model } from "@bryntum/schedulerpro";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const HasStableKeyIdentifierMixin = (target: any) => class extends target {
  private _stableKey: string | undefined;

  get stableKey() {
    if (!this._stableKey) this._stableKey = Model.generateId("stable-key") as string;
    return this._stableKey;
  }
};